
export class Addresses {
    id!: number;
    state!: string;
    municipality!: string;
    colony!: string;
    postal_code!: string;
    street!: string;
    exterior_number!: string;
    interior_number!: string;
}